<template>
  <TemplateModal
    ref="modal"
    center
    width="435"
    :text="{
      button: {
        open: localStorage.translations.pages.projects.reports_dialogs.create_report,
        create: localStorage.translations.pages.projects.reports_dialogs.generate_report,
      },
      title: {
        create: localStorage.translations.pages.projects.reports_dialogs.create_report,
      },
    }"
    :sendFunction="onCreateReport"
  >
    <div class="form_item">
      <label>{{ localStorage.translations.pages.projects.reports_dialogs.generate_report }}</label>
      <transition name="fade" mode="out-in">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              hide-details="auto"
              v-model="dateRangeText"
              outlined
              v-bind="attrs"
              readonly
              prepend-inner-icon="today"
              :placeholder="localStorage.translations.pages.common['text'].not_selected"
              v-on="on"
              :rules="[inputRules.required]"
            ></v-text-field>
          </template>
          <v-date-picker
            :locale="$cookies.get('languageSelect').key"
            v-model="data.dates"
            range
            no-title
            show-week
            first-day-of-week="1"
            :max="new Date().toISOString().slice(0, 10)"
            class="temp"
          >
            <BaseButton
              class="ml-auto mr-0"
              :text="localStorage.translations.pages.common.buttons.confirm"
              :disabled="data.dates.length < 1"
              @click="menu1 = false"
            />
          </v-date-picker>
        </v-menu>
      </transition>
    </div>
  </TemplateModal>
</template>

<script>
// import UsersListItem from 'components/setting/users/UsersListItem'
import TemplateModal from 'components/templates/TemplateModal'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import BaseButton from "components/base/BaseButton";

export default {
  name: 'StatisticProjectReportsModal',
  props: {
    edit: Boolean,
  },
  components: {
    BaseButton,
    TemplateModal,
  },
  data: () => ({
    dialog: false,
    search: '',
    name: null,
    menu1: false,
    data: {
      dates: [],
    },
    autoOpenedQueryKey: '',
  }),
  watch: {
    'data.dates'() {
      if (this.data.dates[0] && this.data.dates[1] && this.data.dates[0] > this.data.dates[1]) {
        this.data.dates = [this.data.dates[1], this.data.dates[0]]
      }
    },
    '$route.query': {
      deep: true,
      handler() {
        this.applyUnreportedRangeFromQuery()
      },
    },
  },
  computed: {
    ...mapGetters(['apiDomain', 'inputRules']),
    ...mapGetters('workClientProjectsPeriodReport', ['workClientProjectsPeriodReportShow']),
    dateStartFormatted() {
      return this.$formatDate(this.data.start_date)
    },
    dateRangeText() {
      let dates = [...this.data.dates]
      if (dates[0]) {
        dates[0] = this.$formatDate(dates[0])
      }
      if (dates[1]) {
        dates[1] = this.$formatDate(dates[1])
      }
      return dates.join(' - ')
    },
  },
  mounted() {
    this.applyUnreportedRangeFromQuery()
  },
  methods: {
    ...mapActions('workClientProjectsPeriodReport', [
      'onWorkClientProjectsPeriodReportGrid',
      'onWorkClientProjectsPeriodReportCreate',
      'onWorkClientProjectsPeriodReportShow',
    ]),
    ...mapActions('workClientProjectsClientReports', [
      'onWorkClientProjectsClientReportsBillCreate',
    ]),
    ...mapMutations('workClientProjectsPeriodReport', ['setWorkClientProjectsPeriodReportShow']),
    defaultData() {
      this.data = {
        dates: [],
      }
    },
    getUnreportedDatesFromQuery() {
      const start = this.$route.query.unreported_start_date
      const end = this.$route.query.unreported_end_date
      if (!start && !end) return null
      const startDate = start || end
      const endDate = end || start
      return [startDate, endDate]
    },
    applyUnreportedRangeFromQuery() {
      const dates = this.getUnreportedDatesFromQuery()
      if (!dates) {
        this.autoOpenedQueryKey = ''
        return
      }
      const normalizedDates = dates[0] > dates[1] ? [dates[1], dates[0]] : dates
      const queryKey = normalizedDates.join('|')
      const hasSameRange =
        this.data.dates[0] === normalizedDates[0] && this.data.dates[1] === normalizedDates[1]
      if (!hasSameRange) {
        this.data.dates = normalizedDates
      }
      if (this.autoOpenedQueryKey === queryKey) return
      this.autoOpenedQueryKey = queryKey
      this.$nextTick(() => {
        if (this.$refs.modal && !this.$refs.modal.dialog) {
          this.$refs.modal.openModal()
        }
      })
    },
    onCreateReport() {
      let data = {
        project_id: this.$route.params.id,
        start_date: this.data.dates[0],
        end_date: this.data.dates[1] ? this.data.dates[1] : this.data.dates[0],
      }
      this.onWorkClientProjectsPeriodReportCreate(data)
        .then((resp) => {
          // this.onWorkClientProjectsPeriodReportGrid({
          //     limit: this.$route.query.limit,
          //     page: this.$route.query.page,
          //     project_id: this.$route.params.id,
          // })
          let respData = resp.data
          this.createBillForReport(respData.id)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications[
                  'izmeneniya-uspeshno-sohraneny'
                ],
              IsError: false,
            },

            { root: true },
          )
          this.setWorkClientProjectsPeriodReportShow(respData)
          this.$router.push({
            name: 'timeControlShowReportsView',
            params: {
              report_id: respData.id,
            },
            query: {
              start: respData.start_date,
              end: respData.end_date,
            },
          })
        })
        .catch((err) => {
          console.log(err)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['oshibka'] +
                ' ' +
                err.response.data.message,
              IsError: true,
            },
            { root: true },
          )
        })

      // this.$router.push({
      //     name: 'timeControlShowReportsView',
      //     query: {
      //         start: this.data.dates[0],
      //         end: this.data.dates[1] ? this.data.dates[1] : this.data.dates[0],
      //     },
      // })
    },
    async createBillForReport(reportId) {
      let billData = {
        period_report_id: reportId,
        employee_reports: [],
        work_extras: [],
        report_with_employee_notes: 0,
        general_note: '',
      }
      await this.onWorkClientProjectsPeriodReportShow(reportId).catch(() => {})
      if (this.workClientProjectsPeriodReportShow && this.workClientProjectsPeriodReportShow.data) {
        let confirmed = this.buildConfirmedReports(this.workClientProjectsPeriodReportShow.data)
        billData.employee_reports = confirmed.work_types
        billData.work_extras = confirmed.extras
      }
      return this.onWorkClientProjectsClientReportsBillCreate({data: billData}).catch(() => {
        this.$store.dispatch(
          'popup/onMessage',
          {
            message: this.localStorage.translations.pages.common.notifications['oshibka'],
            IsError: true,
          },
          { root: true },
        )
      })
    },
    buildConfirmedReports(reportData) {
      let confirmed = {
        work_types: [],
        extras: [],
      }
      if (!reportData || !reportData.employees) {
        return confirmed
      }
      const canBeBilled = (report) => {
        const isEmptyBillId = (value) => {
          return value === null || value === undefined || value === '' || value === 'null'
        }
        if (!report) return false
        if (report.approved_report <= 0) return false
        if (report.client_report_status === 'signed' || report.client_report_status === 'approved') return false
        if (!isEmptyBillId(report.client_bill_id)) return false
        return true
      }
      let employees = Object.values(reportData.employees)
      for (let type in confirmed) {
        for (let id in employees) {
          let days = Object.values(employees[id][type])
            .map(data => Object.values(data.days).map(day => day.reports))
          for (let day in days) {
            for (let work in days[day]) {
              for (let r in days[day][work]) {
                let report = days[day][work][r]
                if (canBeBilled(report)) {
                  confirmed[type].push(report.id)
                }
              }
            }
          }
        }
      }
      return confirmed
    },
  },
}
</script>

<style scoped lang="scss">
:deep() .v-date-picker-table {
  height: auto !important;
}
.temp {
  :deep() .v-input__slot{
  width: max-content !important;
  }
}
</style>
